export const join = (...args: (string | boolean | undefined)[]) =>
  args.filter(Boolean).join(" ")
